import { Component, Output, EventEmitter, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material';

import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';

@Component({
  selector: 'app-construction-site-remark',
  templateUrl: './construction-site-remark.component.html',
  styleUrls: ['./construction-site-remark.component.less']
})
export class ConstructionSiteRemarkComponent {
  @Output('close') closeEvent = new EventEmitter<boolean>();
  @Input('projectId') projectId: string;

  remark = '';
  base64File: string | ArrayBuffer | null = null;
  filename: string | null = null;
  isReadingFile: Boolean = false;

  constructor(
    public snackBar: MatSnackBar,
    private requestService: RequestService,
    private requestV2Service: RequestV2Service
  ) {}

  closeRemark(subject:boolean) {
    this.closeEvent.emit(subject);
  }

  async send() {
    if (this.isReadingFile) {
      this.snackBar.open(
        'Votre fichier est en cours de chargement. Veuillez patienter quelques instants puis \
        réessayer.',
        'Ok',
        {
          duration: 3000
        }
      );

      return;
    }

    const subj = {
      id_project: this.projectId,
      action: this.remark
    };
    const attachment = {
      filename: this.filename,
      data: this.base64File
    };

    if (this.filename !== null || this.base64File !== null) {
      subj['attachment'] = attachment;
    }

    await this.requestV2Service.addProjectSubject(subj);

    this.snackBar.open('Message envoyé', 'Ok', {
      duration: 3000
    });

    this.closeRemark(true);
  }

  onFileChange(event) {
    this.filename = event.target.files[0].name;
    this.getBase64(event.target.files[0]);
  }

  getBase64(file: File) {
    this.isReadingFile = true;

    const reader = new FileReader();

    reader.onload = () => {
      this.isReadingFile = false;

      this.snackBar.open('Fichier correctement chargé', 'Ok', {
        duration: 3000
      });

      this.base64File = reader.result;
    };

    reader.onerror = (error) => {
      this.isReadingFile = false;

      this.snackBar.open(
        'Une erreur est survenu lors du chargement de votre fichier. Merci de réessayer.',
        'Ok',
        {
          duration: 3000
        }
      );

      console.log(error);
    };

    reader.readAsDataURL(file);
  }
}
